<template>
    <div class="or-news-card flex-column column-hor-center column-space-between anim-scale hover-pointer">
        <div class='title-container flex-row row-space-between row-ver-center'>
            <h2 class="title">{{options.title ? options.title.slice(0,100) : 'Новость!'}}</h2>
            <p class="date">{{options.date}}</p>
        </div>
        <div class="content" v-html="text"></div>
        <p class="button hover-white">Подробнее</p>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    props: {
        options: Object,
    },
    computed: {
        text() {
            const result = document.createElement('div');
            const limit = 250;
            let current = 0;
            const div = document.createElement('div');
            this.convertText({text: this.options.text, container: div});
            [...div.children].map(el=>{
                if (current > limit) return
                const length = el.innerText.length;
                if (current + length < limit) {
                } else {
                    const available = limit - current;
                    el.innerText = el.innerText.slice(0, available) + '...';
                }
                    result.appendChild(el);
                    current += length;
            });
            return result.innerHTML;
        }
    },
    methods: {
        ...mapActions({convertText: 'convertText'}),
    }
}
</script>

<style scoped>
    .or-news-card {
        padding: 40px 0;
        box-sizing: border-box;
        width: 1200px;
        height: 196px;
        background-color: #1e1e1e;
        border-radius: 8px;
    }
    .title-container {
        width: 1130px;
    }
    .title {
        font-size: 20px;
        line-height: 23px;
        color: #EBB932;
    }
    .date {
        font-size: 14px;
        line-height: 16px;
        color: #666666;
    }
    .content {
        width: 1130px;
        font-size: 14px;
        line-height: 24px;
        text-align: left;
    }
    .button {
        width: 1130px;
        font-size: 14px;
        line-height: 16px;
        color: #EBB932;
        text-align: left;
    }
</style>